import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import { 
  LOGIN_URL, 
  PLAYER_SIGN_UP_URL, 
  EDIT_PROFILE_URL, 
  INTEGRATIONS_URL, 
  INTEGRATIONS_CHILD_URL
 } from '@/constants/ApiConstants'

const state = {
  errors: null,
  user: window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null,
  isAuthenticated: !!window.localStorage.getItem('user'),
  userEmail: window.localStorage.getItem('userEmail') ? JSON.parse(window.localStorage.getItem('userEmail')) : null,
  isParent: false,
  languageChangedOnSignUp: false,
  childrenForIntegration: null
}

const getters = {
  user: (state) => state.user,
  isAuthenticated: (state) => state.isAuthenticated,
  userEmail: (state) => state.userEmail,
  languageChangedOnSignUp: state => state.languageChangedOnSignUp,
  childrenForIntegration : state => state.childrenForIntegration
}

const actions = {
  [action.LOGIN] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(LOGIN_URL, payload)
        .then(({ data }) => {
          if(data.userDetails && data.userDetails.playerDetails) {
            commit(mutation.SET_CHOSEN_ACCOUNT, data.userDetails.playerDetails[0])
            commit(mutation.SET_SUBACCOUNTS, data.userDetails.playerDetails)
          } else {
            commit(mutation.SET_CHOSEN_ACCOUNT, data.userDetails)
          }
          
          commit(mutation.SET_AUTH, data)
          return resolve(data)
        })
        .catch((error) => {
          return reject(error)
        })
    })
  },
  [action.LOGOUT] ({ commit }) {
    commit(mutation.PURGE_AUTH)
  },
  [action.SIGN_UP] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .postFormData(`${PLAYER_SIGN_UP_URL.replace(':token', payload.token)}`, payload.data)
        .then(({ data, status }) => {
          if(data.userDetails && data.userDetails.playerDetails) {
            commit(mutation.SET_CHOSEN_ACCOUNT, data.userDetails.playerDetails[0])
            commit(mutation.SET_SUBACCOUNTS, data.userDetails.playerDetails)
          } else {
            commit(mutation.SET_CHOSEN_ACCOUNT, data.userDetails)
          }
          
          commit(mutation.SET_AUTH, data)
          // status.code tells the caller whether the account is active (BP_200) or the
          // backend changed the email and is waiting on confirmation (BP_431)
          resolve(Object.assign({}, data, { status }))
        })
        .catch(error => {
          commit(mutation.SET_ERROR, error)
          reject(error)
        })
    })
  },
  [action.UPDATE_ACCOUNT_STATUS] ({ commit }, payload) {
    commit(mutation.UPDATE_USER_ACCOUNT_STATUS, payload)
  },
  [action.EDIT_PROFILE] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .putFormData(`${EDIT_PROFILE_URL.replace(':accountId', payload.id)}`, payload.data)
        .then(({ data }) => {
          commit(mutation.UPDATE_ACCOUNTS, data)
          commit(mutation.SET_CHOSEN_ACCOUNT, data)
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.LANGUAGE_CHANGED_ON_SIGN_UP] ({ commit }, payload) {
    commit(mutation.UPDATE_LANGUAGE_CHANGED_ON_SIGN_UP, true);
  },
  [action.INTEGRATIONS] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(INTEGRATIONS_URL, payload)
        .then((data) => {

            commit(mutation.INTEGRATIONS, data)
            return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.INTEGRATIONS_SELECT_CHILD] ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(INTEGRATIONS_CHILD_URL, payload)
        .then(({ data }) => {
          return resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
}

const mutations = {
  [mutation.SET_ERROR] (state, error) {
    state.errors = error
  },
  [mutation.SET_AUTH] (state, data) {
    state.isAuthenticated = true
    state.user = data.userDetails
    state.userEmail = data.email
    state.errors = {}

    JwtService.saveToken(data.accessToken)
    JwtService.saveRefreshToken(data.refreshToken)
    window.localStorage.setItem('user', JSON.stringify(data.userDetails))
    window.localStorage.setItem('userEmail', JSON.stringify(data.email))
    ApiService.setHeader()
  },
  [mutation.PURGE_AUTH] (state) {
    state.isAuthenticated = false
    state.user = {}
    state.userEmail = {}
    state.errors = {}
    JwtService.destroyToken()
    ApiService.removeTokenAuthHeader()
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('userEmail')
    window.localStorage.removeItem('account')
    window.localStorage.removeItem('calendarFilterData')
  },
  [mutation.UPDATE_USER_ACCOUNT_STATUS] (state, data) {
    let currentUser = JSON.parse(window.localStorage.getItem('user'))
    state.user.playerAccountStatus = data
    currentUser.playerAccountStatus = data
    window.localStorage.setItem('user', JSON.stringify(currentUser));
  },
  [mutation.UPDATE_PROFILE] (state, data) {
    for(var property in data) {
      state.user[property] = data[property]
    }

    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  [mutation.EDIT_USER_EMAIL] (state, payload) {
    state.user.newEmail = payload;
  },
  [mutation.UPDATE_LANGUAGE_CHANGED_ON_SIGN_UP] (state, payload) {
    state.languageChangedOnSignUp = payload;
  },
  [mutation.INTEGRATIONS] (state, payload) {
    if (payload.data) {
      if (payload.data.children) {
        state.childrenForIntegration = payload.data.children;
      } else {
        state.childrenForIntegration = null;
      }
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
